"use client";

import { useTranslations } from "next-intl";

const NAMESPACE = "new-spring-manufacturing";
const STEPS = [
	"processStep1",
	"processStep2",
	"processStep3",
	"processStep4",
	"processStep5",
	"processStep6",
	"processStep7",
	"processStep8",
] as const;

export default function SpringManufacturingProcess() {
	const t = useTranslations(NAMESPACE);

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 text-center sm:mb-10 md:mb-12 lg:mb-16">
					<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
						{t("processTitle")}
					</h2>
					<p className="text-sm leading-relaxed text-black md:text-base">{t("processDesc")}</p>
				</header>

				<div className="grid gap-x-5 gap-y-10 sm:grid-cols-2 lg:grid-cols-4">
					{STEPS.map((step, index) => (
						<article
							key={step}
							className="relative rounded bg-white px-5 pb-6 pt-12 text-center shadow-[0_0_12px_rgba(0,0,0,0.08)]"
						>
							<div className="absolute left-1/2 top-0 flex h-14 w-14 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-themePrimary400 text-2xl font-bold text-white">
								{index + 1}
							</div>
							<h3 className="mb-3 text-base font-bold text-themePrimary400 sm:text-lg">
								{t(`${step}Title`)}
							</h3>
							<p className="text-sm leading-relaxed text-black">{t(`${step}Desc`)}</p>
						</article>
					))}
				</div>
			</div>
		</section>
	);
}
